export const DEMO_ORG_ID = '33333333-3333-3333-3333-333333333333'
export const DEMO_CLIENT_ID = 'c1c1c1c1-0001-4000-a000-000000000001'
export const DEMO_USER_EMAIL = 'demo@aifacilitymanager.com'
export const DEMO_CLIENT_EMAIL = 'client@northstarhockey.demo'
export const DEMO_PASSWORD = 'Demo2026!'

export const isDemoUser = (email?: string | null) => email === DEMO_USER_EMAIL
export const isDemoClient = (email?: string | null) => email === DEMO_CLIENT_EMAIL
export const isDemoAccount = (email?: string | null) => isDemoUser(email) || isDemoClient(email)
export const isDemoOrg = (orgId?: string | null) => orgId === DEMO_ORG_ID

export const DEMO_TOUR_ADMIN_KEY = 'demo-tour-admin-seen'
export const DEMO_TOUR_CLIENT_KEY = 'demo-tour-client-seen'
